module.exports = __webpack_public_path__ + "img/PS27.9680ce15.png";